
// Funzione globale per chiudere drawer e navigare
window.closeDrawerAndNavigate = function(url) {
  const drawer = document.getElementById('sidebar-cart');
  if (drawer) {
    // Chiudi il drawer
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-visible');
    // RIMOSSA: document.body.classList.remove('drawer-open'); - Non più necessaria per evitare spostamenti del layout
    
    // Naviga immediatamente
    window.location.href = url;
  } else {
    // Se non trova il drawer, naviga direttamente
    window.location.href = url;
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // Applica stili dinamici ai pulsanti rimuovi
  function styleRemoveButtons() {
    const removeButtons = document.querySelectorAll('.fx-cart-remove-btn');
    removeButtons.forEach(btn => {
      // Rimuovi event listeners esistenti per evitare duplicati
      btn.removeEventListener('mouseenter', hoverEnter);
      btn.removeEventListener('mouseleave', hoverLeave);
      btn.removeEventListener('click', handleRemoveClick);
      
      // Aggiungi event listeners per hover
      btn.addEventListener('mouseenter', hoverEnter);
      btn.addEventListener('mouseleave', hoverLeave);
      
      // Aggiungi click handler specifico per rimozione
      btn.addEventListener('click', handleRemoveClick);
    });
  }
  
  function hoverEnter() {
    this.style.borderColor = '#E12D2D';
    this.style.color = '#E12D2D';
    this.style.transform = 'scale(1.05)';
    const svg = this.querySelector('svg');
    if (svg) {
      svg.style.color = '#E12D2D';
      svg.style.transform = 'rotate(5deg)';
    }
  }
  
  function hoverLeave() {
    this.style.borderColor = '#e5e5e5';
    this.style.color = '#999';
    this.style.transform = 'scale(1)';
    this.style.boxShadow = '0 3px 10px rgba(0,0,0,0.12)';
    const svg = this.querySelector('svg');
    if (svg) {
      svg.style.color = '#999';
      svg.style.transform = 'rotate(0)';
    }
  }
  
  function handleRemoveClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const itemKey = this.dataset.lineId;
    if (itemKey && window.UltraReactiveCartManager) {
      window.UltraReactiveCartManager.instantUpdateItemQuantity(itemKey, 0);
    }
  }
  
  // Applica stili iniziali
  styleRemoveButtons();
  
  // Riapplica stili quando il carrello si aggiorna
  const observer = new MutationObserver(() => {
    styleRemoveButtons();
  });
  
  const cartContainer = document.getElementById('aiCartItemsList');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
  
  // ============ ULTRA-REACTIVE CART MANAGEMENT CLASS ============ 
  class UltraReactiveCartManager {
    constructor() {
      this.drawer = document.getElementById('sidebar-cart');
      this.itemsList = document.getElementById('aiCartItemsList');
      this.emptyState = document.getElementById('aiEmptyState');
      this.loadingState = document.getElementById('aiCartLoading');
      this.itemsContainer = document.getElementById('aiCartItemsContainer');
      this.footer = document.getElementById('aiCartFooter');
      this.itemCount = document.getElementById('aiItemCount');
      this.totalPrice = document.getElementById('aiTotalPrice');
      this.cartStatus = document.getElementById('aiCartStatus');
      
      this.currentCart = null;
      this.lastUpdateTime = 0;
      this.pendingUpdates = new Set();
      
      // ANTI-LOOP VARIABLES
      this.lastExternalCount = null;
      this.lastExternalHash = null;
      this.externalUpdateTimeout = null;
      this.externalEventTimeout = null;
      this.mutationTimeout = null;
      
      // CACHE per performance
      this.priceCache = new Map();
      this.imageCache = new Map();
      
      // FLAGS per evitare operazioni ridondanti
      this.isRenderingInProgress = false;
      this.lastCartHash = null;
      
      this.init();
    }
    
    init() {
      // SETUP ISTANTANEO
      this.setupInstantEventListeners();
      this.setupPerformanceOptimizedObservers();
      this.loadInitialCartInstant();
      
      // FORCE UPDATE IMMEDIATO
      setTimeout(() => {
        this.instantRefreshCart();
      }, 50);
    }
    
    // ============ SETUP ISTANTANEO EVENT LISTENERS ============
    setupInstantEventListeners() {
      // CONFIGURATOR EVENTS - PRIORITY 1
      window.addEventListener('fxConfigurationApplied', (event) => {
        this.instantCartUpdate('configuration', event.detail);
      });

      // CERAMICA CONFIGURATOR EVENT
      window.addEventListener('ceramicaConfigurationApplied', (event) => {
        this.instantCartUpdate('configuration', event.detail);
      });

      // CART EVENTS - ZERO DELAY
      const criticalCartEvents = [
        'cart:updated', 'cart:refresh', 'cart:item-added', 
        'cart:item-removed', 'cart:change', 'ajaxCart:updated'
      ];
      
      criticalCartEvents.forEach(eventName => {
        document.addEventListener(eventName, (event) => {
          this.instantCartUpdate('cart_event', event.detail);
        }, { passive: true });

        window.addEventListener(eventName, (event) => {
          this.instantCartUpdate('cart_event', event.detail);
        }, { passive: true });
      });
      
      // MUTATION OBSERVER per DOM changes
      this.setupSmartMutationObserver();
      
      // DRAWER CONTROLS
      this.setupOptimizedDrawerControls();
      this.setupOptimizedQuantityControls();
      this.setupOptimizedNoteControls();
    }
    
    // ============ INSTANT CART UPDATE - ZERO THROTTLING ============
    instantCartUpdate(type, data) {
      const updateId = `${type}_${Date.now()}`;
      
      // RIMUOVI throttling - esegui sempre
      if (type === 'configuration' || type === 'cart_event') {
        // IMMEDIATE execution for critical events
        this.performInstantUpdate(updateId, type, data);
      } else {
        // MINIMAL delay for other events
        setTimeout(() => {
          this.performInstantUpdate(updateId, type, data);
        }, 10);
      }
    }
    
    async performInstantUpdate(updateId, type, data) {
      try {
        this.pendingUpdates.add(updateId);

        // FETCH FRESH CART DATA
        const cartData = await this.instantFetchCart();

        if (cartData) {
          this.currentCart = cartData;
          await this.instantRenderCart();
          this.instantUpdateCounters();
          this.instantTriggerExternalUpdates(cartData);
        }

        this.pendingUpdates.delete(updateId);

        // DOUBLE-FETCH per eventi di configurazione/add-to-cart
        // Shopify applica gli automatic discounts DOPO il primo response
        // Un secondo fetch dopo 400ms cattura gli sconti applicati
        if (type === 'configuration') {
          setTimeout(async () => {
            try {
              const updatedCartData = await this.instantFetchCart();

              if (updatedCartData) {
                this.currentCart = updatedCartData;
                await this.instantRenderCart();
                this.instantUpdateCounters();
              }
            } catch (error) {
              // Delayed fetch error (non-critical)
            }
          }, 400);
        }

      } catch (error) {
        this.pendingUpdates.delete(updateId);

        // FALLBACK: Try again with delay
        setTimeout(() => {
          this.instantRefreshCart();
        }, 200);
      }
    }
    
    // ============ INSTANT FETCH - OPTIMIZED ============
    async instantFetchCart() {
      try {
        const startTime = performance.now();
        
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache'
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const cartData = await response.json();
        
        return cartData;
        
      } catch (error) {
        throw error;
      }
    }
    
    // ============ INSTANT RENDER - PERFORMANCE OPTIMIZED ============
    async instantRenderCart() {
      if (this.isRenderingInProgress) {
        return;
      }
      
      this.isRenderingInProgress = true;
      
      try {
        if (!this.currentCart) {
          return;
        }
        
        // HASH CHECK per evitare re-render inutili
        const cartHash = this.generateCartHash(this.currentCart);
        if (cartHash === this.lastCartHash) {
          return;
        }
        this.lastCartHash = cartHash;

        // SVUOTA CACHE PREZZI per ricalcolare con i nuovi valori
        this.priceCache.clear();

        if (this.currentCart.item_count === 0) {
          this.showEmptyStateInstant();
        } else {
          await this.showCartItemsInstant();
        }
        
        this.updatePricingInstant();
        this.updateStatusInstant();
        
      } finally {
        this.isRenderingInProgress = false;
      }
    }
    
    generateCartHash(cart) {
      if (!cart || !cart.items) return 'empty';
      
      const hashData = cart.items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        price: item.price
      }));
      
      return JSON.stringify(hashData) + cart.total_price;
    }
    
    showEmptyStateInstant() {
      // Mostra lo stato vuoto che contiene già il pulsante "Scopri le Categorie"
      if (this.emptyState) {
        this.emptyState.style.display = 'flex';
        // Forza la visibilità del pulsante categorie dentro empty state
        const categoriesBtn = this.emptyState.querySelector('.fx-discover-btn');
        if (categoriesBtn) {
          categoriesBtn.style.display = 'block';
          categoriesBtn.style.opacity = '1';
          categoriesBtn.style.visibility = 'visible';
        }
      }
      
      // Nascondi il contenitore degli items
      if (this.itemsContainer) this.itemsContainer.style.display = 'none';
      
      // NASCONDI IL FOOTER quando il carrello è vuoto
      if (this.footer) {
        this.footer.style.setProperty('display', 'none', 'important');
      }
      
      // RIMUOVI IL BACKGROUND VERDE quando il carrello è vuoto
      if (this.drawer) {
        this.drawer.style.setProperty('background', '#ffffff', 'important');
      }
      
      // Forza un reflow per assicurarsi che le modifiche siano applicate
      if (this.emptyState) {
        this.emptyState.offsetHeight; // Forza reflow
      }
    }
    
    async showCartItemsInstant() {
      if (this.emptyState) this.emptyState.style.display = 'none';
      if (this.itemsContainer) this.itemsContainer.style.display = 'block';
      if (this.footer) this.footer.style.display = 'block';
      
      // RIPRISTINA IL BACKGROUND VERDE quando ci sono prodotti
      if (this.drawer) {
        this.drawer.style.setProperty('background', '#F5F2EB', 'important');
      }
      
      // Mostra il pulsante checkout quando ci sono prodotti
      const checkoutButton = document.getElementById('aiCheckoutButton');
      if (checkoutButton) {
        checkoutButton.style.display = 'flex';
      }
      
      await this.renderCartItemsInstant();
    }
    
    async renderCartItemsInstant() {
      if (!this.itemsList || !this.currentCart.items) return;
      
      // PARALLEL PROCESSING per speed
      const itemsHTMLPromises = this.currentCart.items.map(async (item, index) => {
        return this.generateItemHTMLOptimized(item, index);
      });
      
      const itemsHTMLArray = await Promise.all(itemsHTMLPromises);
      const itemsHTML = itemsHTMLArray.join('');
      
      // BATCH DOM UPDATE
      this.itemsList.innerHTML = itemsHTML;

      // FORCE VISIBILITY - IMMEDIATE
      this.forceElementsVisibilityInstant();
    }
    
    async generateItemHTMLOptimized(item, index) {
      const isConfigured = this.isConfiguredItem(item);
      const isTile = await this.isTileProduct(item);
      // Unità di prezzo: "box" per battiscopa, "mq" per il resto
      const priceUnit = item.properties && item.properties['_Unita_Prezzo'] ? item.properties['_Unita_Prezzo'] : 'mq';
      const imageUrl = item.featured_image ? item.featured_image.url : item.image;
      // VONDOM accessori (SKU VDM-ACC-*): nascondi immagine
      const isVondomAccessorio = (item.sku || '').indexOf('VDM-ACC') === 0;

      // PRICE CALCULATION with caching - STILE CONFIGURATORE
      const priceData = await this.calculatePricesOptimizedUnified(item);

      // IMPORTANTE: Per item dal configuratore, quantity = metri quadri, scatole in _Numero_Scatole
      const displayQuantity = item.properties && item.properties['_Numero_Scatole']
        ? parseInt(item.properties['_Numero_Scatole'])
        : Math.round(item.quantity); // Fallback per item normali o arrotonda i metri quadri

      const quantityMinusOne = Math.max(0, displayQuantity - 1);
      const quantityPlusOne = displayQuantity + 1;

      return `
        <div class="ultra-cart-search-item">
          <div class="ultra-cart-item-header">
            <div class="ultra-cart-item-title">
              <a href="${item.url}">${item.product_title}</a>
            </div>

            <button type="button" class="CartItem__Remove fx-cart-remove-btn ultra-cart-remove-compact" data-quantity="0" data-line-id="${item.key}" data-action="remove-item" title="Rimuovi dal carrello">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6h18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>

          <div class="ultra-cart-item-wrapper${isVondomAccessorio ? ' ultra-cart-item-accessorio' : ''}">
            <div class="ultra-cart-item-top-row">
              ${isVondomAccessorio ? '' : `
              <div class="ultra-cart-item-image">
                <img src="${this.getOptimizedImageUrl(imageUrl, '600x440')}" alt="${item.product_title}" loading="lazy" style="object-fit: cover;">
              </div>`}
              <div class="ultra-cart-item-properties">
                ${this.generatePropertiesListOptimized(item)}
              </div>
            </div>

            <div class="ultra-cart-item-footer-row">
              <div class="CartItem__QuantitySelector ultra-cart-qty-compact">
                <div class="QuantitySelector">
                  <button type="button" class="QuantitySelector__Button" data-quantity="${quantityMinusOne}" data-line-id="${item.key}">
                    <svg class="Icon Icon--minus" viewBox="0 0 16 16"><path d="M0 7h16v2H0z" fill="currentColor"/></svg>
                  </button>
                  <input type="text" class="QuantitySelector__CurrentQuantity" data-line-id="${item.key}" value="${displayQuantity}">
                  <button type="button" class="QuantitySelector__Button" data-quantity="${quantityPlusOne}" data-line-id="${item.key}">
                    <svg class="Icon Icon--plus" viewBox="0 0 16 16"><path d="M8 0v7H0v2h8v7h2V9h6V7h-6V0z" fill="currentColor"/></svg>
                  </button>
                </div>
              </div>
              ${priceData.hasDiscount ? `
                <div class="ultra-cart-item-price-container">
                  <div class="ultra-cart-price-main">
                    <span class="ultra-cart-price-current">${this.formatMoneyOptimized(item.line_price)}</span>
                    <span class="ultra-cart-price-compare">${(priceData.originalPrice && item.price) ? this.formatMoneyOptimized(Math.round(item.line_price * priceData.originalPrice / item.price)) : priceData.formattedOriginalPrice}</span>
                  </div>
                </div>
              ` : `
                <div class="ultra-cart-item-price-container">
                  <div class="ultra-cart-price-main">
                    <span class="ultra-cart-price-current">${this.formatMoneyOptimized(item.line_price)}</span>
                  </div>
                </div>
              `}
            </div>
          </div>
        </div>
      `;
    }
    
    // ============ CALCOLO PREZZI UNIFICATO - STILE CONFIGURATORE ============
    async calculatePricesOptimizedUnified(item) {
      const cacheKey = `${item.variant_id}_${item.line_price}_${item.properties ? JSON.stringify(item.properties) : ''}`;

      if (this.priceCache.has(cacheKey)) {
        return this.priceCache.get(cacheKey);
      }

      // ⚠️ IMPORTANTE: currentPrice deve SEMPRE usare item.line_price per calcoli carrello
      let currentPrice = item.line_price;  // Prezzo REALE per calcoli
      let displayPrice = item.line_price;  // Prezzo per VISUALIZZAZIONE nelle card
      let originalPrice = null;
      let isCeramicaEuro = false;
      let hasPrezzoMqFromConfigurator = false;

      // 🎯 PRIORITÀ 1: Usa _Prezzo_Mq dal configuratore se disponibile
      if (item.properties && item.properties['_Prezzo_Mq']) {
        const prezzoMqStr = item.properties['_Prezzo_Mq'];
        // Parsa "34,90 €" → 3490 (cents)
        const prezzoMqParsed = parseFloat(prezzoMqStr.replace(/[^\d,.-]/g, '').replace(',', '.'));
        if (!isNaN(prezzoMqParsed) && prezzoMqParsed > 0) {
          displayPrice = Math.round(prezzoMqParsed * 100); // Converti in cents
          hasPrezzoMqFromConfigurator = true;
        }
      }

      // 🎯 PRIORITÀ 1B: Usa _Compare_Price_Mq dal configuratore se disponibile
      if (item.properties && item.properties['_Compare_Price_Mq']) {
        const comparePriceStr = item.properties['_Compare_Price_Mq'];
        // Parsa "168,00 €" → 16800 (cents)
        const comparePriceParsed = parseFloat(comparePriceStr.replace(/[^\d,.-]/g, '').replace(',', '.'));
        if (!isNaN(comparePriceParsed) && comparePriceParsed > 0) {
          originalPrice = Math.round(comparePriceParsed * 100); // Converti in cents
        }
      }

      // Fetch product data
      try {
        const productResponse = await fetch(`/products/${item.handle}.js`);
        if (productResponse.ok) {
          const productData = await productResponse.json();
          const variant = productData.variants.find(v => v.id === item.variant_id);

          // 🎯 Rileva se è prodotto Ceramica Euro
          isCeramicaEuro = productData.vendor === 'CERAMICAEURO' ||
                          (item.properties && item.properties['_Configuratore'] &&
                           item.properties['_Configuratore'].includes('CERAMICAEURO'));

          // 💰 Se NON abbiamo già il prezzo dal configuratore, cerca prezzo fisso al mq per TUTTI i vendor
          if (!hasPrezzoMqFromConfigurator && typeof window.getPrezzoFissoM2 === 'function') {
            let formato = null;

            if (variant && variant.option1 && variant.option1.match(/\d+\s*[x×]\s*\d+/i)) {
              formato = variant.option1.match(/(\d+)\s*[x×]\s*(\d+)/i)[0].replace(/\s+/g, '').toLowerCase();
            } else if (variant && variant.title && variant.title.match(/\d+\s*[x×]\s*\d+/i)) {
              formato = variant.title.match(/(\d+)\s*[x×]\s*(\d+)/i)[0].replace(/\s+/g, '').toLowerCase();
            } else if (item.properties && item.properties['Formato']) {
              const formatoMatch = item.properties['Formato'].match(/(\d+)\s*[x×]\s*(\d+)/i);
              if (formatoMatch) formato = formatoMatch[0].replace(/\s+/g, '').toLowerCase();
            }

            if (formato) {
              const prezziFissi = window.getPrezzoFissoM2(formato, productData.title);
              if (prezziFissi) {
                // ✅ displayPrice = prezzo UNITARIO fisso al m² (solo visualizzazione)
                displayPrice = prezziFissi.prezzo;
                /* KH 07/08: barrato SOLO da compare_at reale Shopify (rimosso listino) */
                hasPrezzoMqFromConfigurator = true; // Trattalo come se fosse dal configuratore
                // ⚠️ currentPrice rimane item.line_price (prezzo REALE per calcoli)
              }
            }
          }

          // 🎯 Se abbiamo prezzo dal configuratore, cerca compare price al mq con getPrezzoFissoM2
          if (hasPrezzoMqFromConfigurator && !originalPrice && typeof window.getPrezzoFissoM2 === 'function') {
            let formato = null;
            if (variant && variant.option1 && variant.option1.match(/\d+\s*[x×]\s*\d+/i)) {
              formato = variant.option1.match(/(\d+)\s*[x×]\s*(\d+)/i)[0].replace(/\s+/g, '').toLowerCase();
            } else if (variant && variant.title && variant.title.match(/\d+\s*[x×]\s*\d+/i)) {
              formato = variant.title.match(/(\d+)\s*[x×]\s*(\d+)/i)[0].replace(/\s+/g, '').toLowerCase();
            } else if (item.properties && item.properties['Formato']) {
              const formatoMatch = item.properties['Formato'].match(/(\d+)\s*[x×]\s*(\d+)/i);
              if (formatoMatch) formato = formatoMatch[0].replace(/\s+/g, '').toLowerCase();
            }

            if (formato) {
              const prezziFissi = window.getPrezzoFissoM2(formato, productData.title);
              if (prezziFissi && prezziFissi.comparePrice) {
                /* KH 07/08: barrato SOLO da compare_at reale Shopify (rimosso listino) */ // Prezzo listino al mq
              }
            }
          }

          // Fallback: usa compare_at_price Shopify (solo se NON abbiamo prezzo dal configuratore)
          if (!hasPrezzoMqFromConfigurator && !isCeramicaEuro && !originalPrice && variant && variant.compare_at_price) {
            originalPrice = variant.compare_at_price * item.quantity;
          }
        }
      } catch (error) {
        
      }

      let hasDiscount = false;
      let savingsAmount = 0;
      let discountPercentage = 0;

      // Calcola sconto tra originalPrice e displayPrice (per visualizzazione)
      if (originalPrice && originalPrice > displayPrice) {
        hasDiscount = true;
        savingsAmount = originalPrice - displayPrice;
        discountPercentage = Math.round((savingsAmount / originalPrice) * 100);
      }

      const result = {
        hasDiscount,
        discountPercentage,
        displayPrice: displayPrice, originalPrice: originalPrice,
        formattedPrice: this.formatMoneyOptimized(displayPrice),  // ✅ Usa displayPrice per card
        formattedOriginalPrice: hasDiscount ? this.formatMoneyOptimized(originalPrice) : null,
        formattedSavings: hasDiscount ? this.formatMoneyOptimized(savingsAmount) : null
      };

      // CACHE THE RESULT
      this.priceCache.set(cacheKey, result);

      return result;
    }
    
    generatePropertiesListOptimized(item) {
      if ((!item.properties || Object.keys(item.properties).length === 0) && !item.variant_title) {
        return '';
      }

      // Ordine desiderato: Destinazione, Formato, Finitura, Colore, Spessore, Vondom/Arcadia
      const propertyOrder = ['Destinazione', 'Formato', 'Finitura', 'Colore', 'Colore Struttura', 'Colore Tessuto', 'Spessore'];
      const propertyItems = [];
      const processedKeys = new Set();

      // Prima: aggiungi proprietà nell'ordine specificato
      for (const key of propertyOrder) {
        if (!item.properties || !item.properties[key]) continue;
        if (item.properties[key]) {
          const value = item.properties[key];
          if (value === '' || key.charAt(0) === '_') continue;

          const valueLower = String(value).toLowerCase();
          if (valueLower.includes('non selezionat') ||
              valueLower.includes('non configurat') ||
              valueLower === 'nessuno' ||
              valueLower === 'none') continue;

          propertyItems.push(`<li class="CartItem__Property"><span class="cart-prop-label">${key}</span><span class="cart-prop-value">${value}</span></li>`);
          processedKeys.add(key);
        }
      }

      // Poi: aggiungi le proprietà rimanenti
      for (const [key, value] of Object.entries(item.properties)) {
        if (processedKeys.has(key)) continue;
        if (value === '' || key.charAt(0) === '_') continue;
        if (/^prezzo al m/i.test(key)) continue; // KH 16/09: "Prezzo al m²" -> sostituito da "Superficie" (totale m²)
        if (/^superficie$/i.test(key)) continue; // KH 23/09: Superficie calcolata live sotto (evita doppione con la property)
        if (/^prezzo alla scatola$/i.test(key)) continue; // KH 23/09: iniettata a fine (ordine coerente)

        const valueLower = String(value).toLowerCase();
        if (valueLower.includes('non selezionat') ||
            valueLower.includes('non configurat') ||
            valueLower === 'nessuno' ||
            valueLower === 'none') continue;

        propertyItems.push(`<li class="CartItem__Property"><span class="cart-prop-label">${key}</span><span class="cart-prop-value">${value}</span></li>`);
      }

      // KH 23/09: Prezzo al m² (live dal prezzo unitario nativo Shopify, o dal _Prezzo_Mq)
      let khPrezzoMq = null;
      if (item.unit_price && item.unit_price_measurement && (item.unit_price_measurement.reference_unit === 'm2' || item.unit_price_measurement.quantity_unit === 'm2')) {
        khPrezzoMq = this.formatMoneyOptimized(item.unit_price) + '/m²';
      } else if (item.properties && item.properties['_Prezzo_Mq']) {
        khPrezzoMq = String(item.properties['_Prezzo_Mq']).replace('/mq', '/m²');
      }
      if (khPrezzoMq) {
        propertyItems.push('<li class="CartItem__Property"><span class="cart-prop-label">Prezzo al m²</span><span class="cart-prop-value">' + khPrezzoMq + '</span></li>');
      }
      // KH 16/09: al posto di "Prezzo al m²" mostro il TOTALE dei m². Calcolo SEMPRE LIVE (m²/scatola ×
      // quantità corrente) così si aggiorna al cambio quantità anche se _Total_Mq resta statico (change.js).
      let khTotalMq = null;
      const khQty = item.quantity || 1;
      // 1) m²/scatola NATIVO Shopify (unit_price_measurement) × quantità corrente
      if (item.unit_price_measurement && item.unit_price_measurement.quantity_value &&
          (item.unit_price_measurement.quantity_unit === 'm2' || item.unit_price_measurement.reference_unit === 'm2')) {
        khTotalMq = parseFloat(item.unit_price_measurement.quantity_value) * khQty;
      }
      // 2) fallback: rapporto m²/scatola dalle properties × quantità corrente
      if ((!khTotalMq || isNaN(khTotalMq)) && item.properties && item.properties['_Total_Mq'] && item.properties['_Numero_Scatole']) {
        const khMqBox = parseFloat(String(item.properties['_Total_Mq']).replace(',', '.')) / parseInt(item.properties['_Numero_Scatole']);
        if (khMqBox && !isNaN(khMqBox)) khTotalMq = khMqBox * khQty;
      }
      // 3) ultimo fallback: _Total_Mq statico
      if ((!khTotalMq || isNaN(khTotalMq)) && item.properties && item.properties['_Total_Mq']) {
        khTotalMq = parseFloat(String(item.properties['_Total_Mq']).replace(',', '.'));
      }
      if (khTotalMq && !isNaN(khTotalMq) && khTotalMq > 0) {
        // KH 30/09: n° scatole per-riga (v3 = quantity; universale = _Numero_Scatole)
        const khScatole = (item.properties && item.properties['_Numero_Scatole']) ? parseInt(item.properties['_Numero_Scatole']) : khQty;
        if (khScatole && !isNaN(khScatole) && khScatole > 0) {
          propertyItems.push('<li class="CartItem__Property"><span class="cart-prop-label">N. scatole</span><span class="cart-prop-value">' + khScatole + '</span></li>');
        }
        const khMqStr = khTotalMq.toFixed(2).replace('.', ',') + ' m²';
        propertyItems.push('<li class="CartItem__Property"><span class="cart-prop-label">Superficie</span><span class="cart-prop-value">' + khMqStr + '</span></li>');
      }

      // NOTA: l'iniezione di Struttura/Tessuto dal variant title viene fatta
      // dallo script in product.prodotti.liquid (options_with_values).
      // Qui evito di duplicare.

      if (item.price && ((item.properties && (item.properties['_Prezzo_Mq'] || item.properties['Prezzo alla scatola'] || item.properties['_Mq_Per_Box'])) || (item.unit_price && item.unit_price_measurement && (item.unit_price_measurement.reference_unit === 'm2' || item.unit_price_measurement.quantity_unit === 'm2')))) { propertyItems.push('<li class="CartItem__Property"><span class="cart-prop-label">Prezzo alla scatola</span><span class="cart-prop-value">' + this.formatMoneyOptimized(item.price) + '</span></li>'); }

      if (propertyItems.length === 0) return '';

      return `<ul class="CartItem__PropertyList">${propertyItems.join('')}</ul>`;
    }
    
    async isTileProduct(item) {
      // Se ha properties del configuratore, è sicuramente una piastrella
      if (item.properties && item.properties['_Configuratore'] && item.properties['_Configuratore'].includes('CERAMICAEURO')) {
        return true;
      }

      // Altrimenti, verifica tramite product_type e tags
      try {
        const productResponse = await fetch(`/products/${item.handle}.js`);
        if (productResponse.ok) {
          const productData = await productResponse.json();
          const productType = productData.product_type || productData.type || '';
          const tags = productData.tags || [];

          // Parole chiave per identificare le piastrelle
          const tileKeywords = ['piastrelle', 'piastrella', 'tile', 'tiles', 'ceramica', 'gres', 'porcellanato'];

          // Controlla product_type
          const typeMatch = tileKeywords.some(keyword => productType.toLowerCase().includes(keyword));
          if (typeMatch) return true;

          // Controlla tags
          const tagsString = Array.isArray(tags) ? tags.join(' ').toLowerCase() : String(tags).toLowerCase();
          const tagsMatch = tileKeywords.some(keyword => tagsString.includes(keyword));
          if (tagsMatch) return true;
        }
      } catch (error) {
        
      }

      return false;
    }

    isConfiguredItem(item) {
      return item.properties &&
        item.properties['_Configuratore'] &&
        item.properties['_Configuratore'].includes('CERAMICAEURO');
    }
    
    // ============ INSTANT UPDATE FUNCTIONS ============
    updatePricingInstant() {
      if (!this.currentCart) {
        return;
      }

      // ⚠️ IMPORTANTE: Shopify ha già applicato lo sconto al line_price
      // Dobbiamo solo MOSTRARE il breakdown corretto, non ricalcolare il totale

      let subtotalBeforeBancale = 0;  // Subtotale PRIMA dello sconto (da original_line_price)
      let totalBancaleDiscount = 0;   // Sconto bancale calcolato
      let actualTotal = 0;             // Totale REALE da Shopify (line_price già scontato)

      if (this.currentCart.items && this.currentCart.items.length > 0) {
        this.currentCart.items.forEach(item => {
          // ✅ Il subtotale è il prezzo PRIMA degli sconti
          const itemOriginalPrice = item.original_line_price || item.line_price;
          subtotalBeforeBancale += itemOriginalPrice;

          const mqReali = item.properties && item.properties['_Total_Mq']
            ? parseFloat(item.properties['_Total_Mq'])
            : item.quantity / 100;

          // 🔍 Verifica se Shopify ha già applicato automatic discount
          let itemFinalPrice = item.line_price;
          let discountAmount = 0;

          if (item.original_line_price && item.original_line_price > item.line_price) {
            // ✅ Shopify ha già applicato automatic discount
            discountAmount = item.original_line_price - item.line_price;
            totalBancaleDiscount += discountAmount;
            itemFinalPrice = item.line_price;
          } else {
            // ⚠️ Nessun automatic discount, calcola lo sconto bancale manualmente
            let discountPercentage = 0;

            if (item.properties && item.properties['_Numero_Scatole']) {
              const numeroScatole = parseInt(item.properties['_Numero_Scatole']);
              const boxesPerPallet = item.properties['_Boxes_Per_Pallet']
                ? parseInt(item.properties['_Boxes_Per_Pallet'])
                : 40;

              // Usa BancaleDiscount per ottenere la percentuale corretta per il vendor
              const numeroBancali = Math.floor(numeroScatole / boxesPerPallet);
              if (window.BancaleDiscount && numeroBancali >= 1) {
                discountPercentage = window.BancaleDiscount.calculateDiscount(numeroBancali);
              }

              if (discountPercentage > 0) {
                // Formula Appstle: sconto sul totale, non per unità (più preciso)
                discountAmount = Math.round(item.line_price * discountPercentage / 100);
                totalBancaleDiscount += discountAmount;
                itemFinalPrice = item.line_price - discountAmount;
              }
            }
          }

          actualTotal += itemFinalPrice;
        });
      } else {
        actualTotal = this.currentCart.total_price;
        subtotalBeforeBancale = this.currentCart.original_total_price || this.currentCart.total_price;
      }

      // ✅ USA IL TOTALE REALE DI SHOPIFY (non ricalcolare!)
      const finalTotal = actualTotal;
      const totalPrice = this.formatMoneyOptimized(finalTotal);

      // Aggiorna il contenitore principale mantenendo la struttura per Revy
      const totalPriceElement = document.getElementById('aiTotalPrice');

      if (totalPriceElement) {
        totalPriceElement.innerHTML = `<span id='revy-cart-subtotal-price'>${totalPrice}</span>`;
      }

      // ============ AGGIORNA BREAKDOWN (Subtotale, Sconti, Totale) ============
      // Il subtotale è il prezzo PRIMA dello sconto bancale
      const displaySubtotal = subtotalBeforeBancale;

      // Lo sconto è il totale degli sconti bancale
      const displayDiscount = totalBancaleDiscount;

      // Aggiorna gli elementi del breakdown (usa data attributes per selezione più veloce)
      const subtotalRow = document.querySelector('[data-subtotal-row]');
      const subtotalElement = document.querySelector('[data-breakdown-subtotal]');
      const discountRow = document.querySelector('[data-discount-row]');
      const discountElement = document.querySelector('[data-breakdown-discount]');
      const divider = document.querySelector('[data-divider]');
      const finalTotalElement = document.querySelector('[data-breakdown-total]');

      // Mostra/nascondi subtotale, riga sconti e divider (totale sempre visibile)
      if (subtotalRow && discountRow && divider) {
        if (displayDiscount > 0) {
          subtotalRow.style.display = 'flex';
          discountRow.style.display = 'flex';
          divider.style.display = 'block';
        } else {
          subtotalRow.style.display = 'none';
          discountRow.style.display = 'none';
          divider.style.display = 'none';
        }
      }

      // Aggiorna sempre i valori
      if (subtotalElement) {
        subtotalElement.innerHTML = this.formatMoneyOptimized(displaySubtotal);
      }

      if (discountElement) {
        discountElement.textContent = '-' + this.formatMoneyOptimized(displayDiscount);
      }

      if (finalTotalElement) {
        finalTotalElement.innerHTML = totalPrice;
      }
    }
    
    instantUpdateCounters() {
      if (!this.currentCart) return;
      
      const count = this.currentCart.item_count;
      const text = count === 1 ? 'confezione' : 'confezioni';
      
      // ONLY update internal drawer elements
      if (this.itemCount) {
        this.itemCount.textContent = `${count} ${text}`;
      }
      
      // CONTROLLED update of external counters with debouncing
      this.debouncedUpdateExternalCounters(count);
    }
    
    debouncedUpdateExternalCounters(count) {
      // Clear existing timeout
      if (this.externalUpdateTimeout) {
        clearTimeout(this.externalUpdateTimeout);
      }
      
      // Debounce external updates to prevent loops
      this.externalUpdateTimeout = setTimeout(() => {
        // Only update if count actually changed
        if (this.lastExternalCount !== count) {
          this.lastExternalCount = count;
          
          // SELECTIVE update - avoid touching header price elements
          const cartCountElements = document.querySelectorAll('.mobile-cart-count-clean');
          cartCountElements.forEach(element => {
            element.textContent = count;
            
            if (count > 0) {
              element.classList.add('has-items');
              if (!element.classList.contains('pulse-badge')) {
                element.classList.add('pulse-badge');
                setTimeout(() => element.classList.remove('pulse-badge'), 600);
              }
            } else {
              element.classList.remove('has-items');
            }
          });
        }
      }, 300);
    }
    
    updateStatusInstant() {
      if (!this.cartStatus) return;

      const count = this.currentCart ? this.currentCart.item_count : 0;
      if (count > 0) {
        this.cartStatus.textContent = count;
        this.cartStatus.style.display = 'inline-flex';
      } else {
        this.cartStatus.style.display = 'none';
      }
    }
    
    instantTriggerExternalUpdates(cartData) {
      // CONTROLLED external updates with debouncing
      if (this.externalEventTimeout) {
        clearTimeout(this.externalEventTimeout);
      }
      
      this.externalEventTimeout = setTimeout(() => {
        // Only dispatch if cart actually changed
        const cartHash = this.generateCartHash(cartData);
        if (this.lastExternalHash !== cartHash) {
          this.lastExternalHash = cartHash;
          
          // MINIMAL event dispatching to prevent loops
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cartData }
          }));
        }
      }, 500); // 500ms debounce for external events
    }
    
    // ============ OPTIMIZED EVENT HANDLERS ============
    setupOptimizedQuantityControls() {
      // SUPPORTO MOBILE MIGLIORATO
      const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
      
      // Debounce map per quantità
      this._qtyDebounceTimers = this._qtyDebounceTimers || {};
      this._qtyPendingValues = this._qtyPendingValues || {};

      const handleInteraction = (e) => {
        // QUANTITY BUTTONS - ora gestisce sia <a> che <button>
        const quantityButton = e.target.closest('.QuantitySelector__Button');
        if (quantityButton) {
          e.preventDefault();
          e.stopPropagation();

          const itemKey = quantityButton.dataset.lineId;
          const newQuantity = parseInt(quantityButton.dataset.quantity);

          if (itemKey && newQuantity !== undefined && newQuantity >= 0) {
            // IMMEDIATE UI: aggiorna numero subito
            const input = quantityButton.closest('.QuantitySelector')?.querySelector('.QuantitySelector__CurrentQuantity');
            if (input) {
              input.value = newQuantity;
              // Aggiorna data-quantity sui pulsanti fratelli
              const btns = quantityButton.closest('.QuantitySelector')?.querySelectorAll('.QuantitySelector__Button');
              if (btns && btns.length === 2) {
                btns[0].dataset.quantity = Math.max(0, newQuantity - 1);
                btns[1].dataset.quantity = newQuantity + 1;
              }
            }

            // DEBOUNCE: aspetta 400ms prima di chiamare API
            this._qtyPendingValues[itemKey] = newQuantity;
            clearTimeout(this._qtyDebounceTimers[itemKey]);
            this._qtyDebounceTimers[itemKey] = setTimeout(() => {
              const finalQty = this._qtyPendingValues[itemKey];
              delete this._qtyPendingValues[itemKey];
              this.instantUpdateItemQuantity(itemKey, finalQty);
            }, 400);
          }
          return false;
        }
        
        // REMOVE BUTTON - feedback visivo immediato
        const removeButton = e.target.closest('.CartItem__Remove, .fx-cart-remove-btn');
        if (removeButton) {
          e.preventDefault();
          e.stopPropagation();

          const itemKey = removeButton.dataset.lineId;

          if (itemKey) {
            // IMMEDIATE: nascondi la card subito
            const card = removeButton.closest('.ultra-cart-search-item');
            if (card) {
              card.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
              card.style.opacity = '0';
              card.style.transform = 'translateX(50px)';
            }
            // Cancella eventuali debounce pendenti per questo item
            clearTimeout(this._qtyDebounceTimers?.[itemKey]);
            delete this._qtyPendingValues?.[itemKey];
            this.instantUpdateItemQuantity(itemKey, 0);
          }
          return false;
        }
        
        // CART DRAWER OPEN TRIGGERS - aggiunti più selettori
        const openTriggers = [
          '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]',
          '.cart-drawer-toggle',
          '.Header__CartIcon',
          '.mobile-cart-trigger',
          '.cart-icon',
          '.cart-link',
          '[href="/cart"]'
        ];
        
        for (const selector of openTriggers) {
          if (e.target.closest(selector)) {
            e.preventDefault();
            e.stopPropagation();
            this.openDrawerInstant();
            return false;
          }
        }
        
        // CHECKOUT BUTTON - VERIFICA E CORREGGI QUANTITÀ PRIMA DI CHECKOUT
        const checkoutButton = e.target.closest('.fx-checkout-btn, #aiCheckoutButton');
        if (checkoutButton) {
          e.preventDefault();
          e.stopPropagation();

          // Mostra loading
          const originalText = checkoutButton.textContent;
          checkoutButton.disabled = true;
          checkoutButton.textContent = 'Verifica carrello...';

          // VERIFICA QUANTITÀ E TRIGGERA SCONTI APPSTLE PRIMA DEL CHECKOUT
          const verifyAndFixCart = async () => {
            try {
              // STEP 1: Fetch carrello con XMLHttpRequest (bypassa interceptor per vedere quantità reali)
              const cartData = await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', '/cart.js?t=' + Date.now(), true);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.onload = () => {
                  if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(JSON.parse(xhr.responseText));
                  } else {
                    reject(new Error('Failed to fetch cart'));
                  }
                };
                xhr.onerror = () => reject(new Error('Network error'));
                xhr.send();
              });


              // STEP 2: Verifica e correggi quantità se necessario
              let needsFix = false;
              for (const item of cartData.items) {
                if (item.properties && item.properties['_Numero_Scatole']) {
                  const expectedQuantity = parseInt(item.properties['_Numero_Scatole']);
                  if (item.quantity !== expectedQuantity) {
                    
                    needsFix = true;

                    // CORREGGI con XMLHttpRequest (bypassa interceptor per mantenere quantità!)
                    checkoutButton.textContent = 'Correzione quantità...';
                    await new Promise((resolve, reject) => {
                      const xhr = new XMLHttpRequest();
                      xhr.open('POST', '/cart/change.js?t=' + Date.now(), true);
                      xhr.setRequestHeader('Content-Type', 'application/json');
                      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                      xhr.onload = () => {
                        resolve();
                      };
                      xhr.onerror = () => reject(new Error('Network error'));
                      xhr.send(JSON.stringify({
                        id: item.key,
                        quantity: expectedQuantity
                      }));
                    });
                  }
                }
              }

              // STEP 3: TRIGGERA APPSTLE per calcolo sconti volume!
              // Usa fetch normale così Appstle interceptor vede il carrello e calcola sconti
              checkoutButton.textContent = 'Attendere...';

              try {
                // Questo fetch viene intercettato da Appstle che calcola gli sconti
                await fetch('/cart.js?appstle_refresh=' + Date.now(), {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' }
                });

                // Attendi che Appstle processi gli sconti
                await new Promise(r => setTimeout(r, 300));

                // Secondo fetch per assicurarsi che gli sconti siano applicati
                await fetch('/cart.js', {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' }
                });

              } catch (e) {
              }

              // Attendi sincronizzazione finale
              await new Promise(r => setTimeout(r, 200));

              return true;
            } catch (error) {
              
              return false;
            }
          };

          // Esegui verifica e poi checkout
          verifyAndFixCart().then((success) => {
            checkoutButton.textContent = 'Preparazione ordine...';

            const form = checkoutButton.closest('form');
            if (form) {
              const checkoutInput = document.createElement('input');
              checkoutInput.type = 'hidden';
              checkoutInput.name = 'checkout';
              checkoutInput.value = '1';
              form.appendChild(checkoutInput);

              setTimeout(() => {
                form.submit();
              }, 100);
            } else {
              window.location.href = '/checkout';
            }
          });

          return false;
        }
      };
      
      // Event listeners per mobile e desktop
      document.addEventListener('click', handleInteraction, { passive: false });
      
      // Supporto touch migliorato per mobile
      if (isTouchDevice) {
        let touchHandled = false;
        
        document.addEventListener('touchstart', (e) => {
          touchHandled = false;
        }, { passive: true });
        
        document.addEventListener('touchend', (e) => {
          if (!touchHandled) {
            touchHandled = true;
            handleInteraction(e);
          }
        }, { passive: false });
      }
      
      // QUANTITY INPUT CHANGES
      document.addEventListener('change', (e) => {
        const quantityInput = e.target.closest('.QuantitySelector__CurrentQuantity');
        if (quantityInput) {
          e.preventDefault();
          
          const itemKey = quantityInput.dataset.lineId;
          const newQuantity = parseInt(quantityInput.value) || 0;
          
          if (itemKey && newQuantity >= 0) {
            this.instantUpdateItemQuantity(itemKey, newQuantity);
          }
        }
      });
    }
    
    async instantUpdateItemQuantity(itemKey, quantity) {
      // Previeni chiamate multiple parallele per lo stesso item
      if (this._updatingItems?.has(itemKey)) return;
      if (!this._updatingItems) this._updatingItems = new Set();
      this._updatingItems.add(itemKey);

      try {
        // Trova l'item nel carrello
        const item = this.currentCart.items.find(i => i.key === itemKey);

        // Invalida solo la cache di questo item (non tutta)
        if (item) {
          for (const [key] of this.priceCache) {
            if (key.startsWith(String(item.variant_id))) this.priceCache.delete(key);
          }
        }

        // IMMEDIATE UI FEEDBACK
        this.showInstantFeedback(itemKey, quantity);

        // OPTIMISTIC PRICING — aggiorna totali subito senza aspettare server
        if (item) {
          this.optimisticUpdatePricing(item, quantity);
        }

        // Per item del configuratore: rimuovi e riaggiungi con properties aggiornate
        // (Shopify /cart/change.js NON supporta l'aggiornamento delle properties!)
        // USA XMLHttpRequest per BYPASSARE l'interceptor di appstle-bundles!
        if (item && item.properties && item.properties['_Numero_Scatole'] && item.properties['_Total_Mq']) {
          const scatoleOriginali = parseInt(item.properties['_Numero_Scatole']);
          const mqOriginali = parseFloat(item.properties['_Total_Mq']);
          const mqPerScatola = mqOriginali / scatoleOriginali;

          const mqReali = quantity * mqPerScatola;

          // IMPORTANTE: quantity per Shopify = NUMERO DI SCATOLE (non centesimi di m²!)
          const shopifyQuantity = quantity;

          // Crea nuove properties con valori aggiornati
          const updatedProperties = {
            ...item.properties,
            '_Numero_Scatole': quantity.toString(),
            '_Total_Mq': mqReali.toFixed(2)
          };

          // Helper per XMLHttpRequest (bypassa appstle-bundles interceptor)
          const xhrRequest = (url, data) => new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url + '?t=' + Date.now(), true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = () => resolve(xhr.status >= 200 && xhr.status < 300);
            xhr.onerror = () => reject(new Error('Network error'));
            xhr.send(JSON.stringify(data));
          });

          // Se quantity = 0, rimuovi semplicemente
          if (quantity === 0) {
            await xhrRequest('/cart/change.js', { id: itemKey, quantity: 0 });
          } else {
            // STEP 1: Rimuovi l'item esistente
            await xhrRequest('/cart/change.js', { id: itemKey, quantity: 0 });

            // STEP 2: Riaggiungi con nuove properties (BYPASS appstle interceptor!)
            await xhrRequest('/cart/add.js', {
              items: [{
                id: item.variant_id,
                quantity: shopifyQuantity,
                properties: updatedProperties
              }]
            });
          }
        } else {
          // Item normale: usa /cart/change.js standard (anche qui XMLHttpRequest)
          const xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/change.js?t=' + Date.now(), true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
          xhr.send(JSON.stringify({ id: itemKey, quantity: quantity }));
          await new Promise(r => xhr.onload = r);
        }

        // Fetch carrello aggiornato (usa XMLHttpRequest per bypassare interceptor)
        const response = await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', '/cart.js?t=' + Date.now(), true);
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
          xhr.onload = () => resolve({ ok: xhr.status >= 200 && xhr.status < 300, json: () => Promise.resolve(JSON.parse(xhr.responseText)) });
          xhr.onerror = () => reject(new Error('Network error'));
          xhr.send();
        });
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const cartData = await response.json();

        this.currentCart = cartData;

        // Aggiorna subito il prezzo prima del render
        this.updatePricingInstant();

        // Se il carrello è vuoto dopo la rimozione, mostra immediatamente lo stato vuoto
        if (cartData.item_count === 0) {
          this.showEmptyStateInstant();
          this.instantUpdateCounters();
        } else {
          await this.instantRenderCart();
          this.instantUpdateCounters();
        }

        this.instantTriggerExternalUpdates(cartData);

        // HAPTIC FEEDBACK
        if (navigator.vibrate) {
          navigator.vibrate(quantity === 0 ? [50, 100, 50] : 50);
        }

        // RICALCOLA SCONTO BANCALE VIA WORKER (non blocca UI)
        void 0 /* sconto bancale rimosso */;

        // DOUBLE-FETCH per aggiornare prezzi dopo che Shopify applica il codice sconto
        setTimeout(async () => {
          try {
            const updatedCartData = await this.instantFetchCart();
            if (updatedCartData) {
              this.currentCart = updatedCartData;
              this.updatePricingInstant();
              this.instantUpdateCounters();
            }
          } catch (error) {}
        }, 2000);

      } catch (error) {

        // IMMEDIATE RECOVERY
        setTimeout(() => {
          this.instantRefreshCart();
        }, 100);
      } finally {
        this._updatingItems?.delete(itemKey);
      }
    }
    
    optimisticUpdatePricing(item, newQuantity) {
      // Calcola il delta di prezzo IMMEDIATAMENTE senza server
      const oldQuantity = item.properties && item.properties['_Numero_Scatole']
        ? parseInt(item.properties['_Numero_Scatole'])
        : item.quantity;
      const pricePerUnit = item.price; // prezzo per unità in centesimi
      const oldLinePrice = item.line_price;
      const newLinePrice = newQuantity === 0 ? 0 : Math.round(pricePerUnit * newQuantity);
      const priceDelta = newLinePrice - oldLinePrice;

      // Aggiorna contatore articoli subito
      const newItemCount = newQuantity === 0
        ? this.currentCart.item_count - oldQuantity
        : this.currentCart.item_count + (newQuantity - oldQuantity);
      if (this.itemCount) {
        this.itemCount.textContent = `${Math.max(0, newItemCount)} ${newItemCount === 1 ? 'confezione' : 'confezioni'}`;
      }

      // Aggiorna totale nel footer subito
      const newTotal = Math.max(0, this.currentCart.total_price + priceDelta);
      const finalTotalElement = document.querySelector('[data-breakdown-total]');
      if (finalTotalElement) {
        finalTotalElement.innerHTML = this.formatMoneyOptimized(newTotal);
      }

      // Aggiorna subtotale
      const newSubtotal = Math.max(0, (this.currentCart.original_total_price || this.currentCart.total_price) + priceDelta);
      const subtotalElement = document.querySelector('[data-breakdown-subtotal]');
      if (subtotalElement) {
        subtotalElement.innerHTML = this.formatMoneyOptimized(newSubtotal);
      }

      // Se rimozione e carrello diventa vuoto, mostra stato vuoto subito
      if (newQuantity === 0 && newItemCount <= 0) {
        setTimeout(() => this.showEmptyStateInstant(), 250);
      }
    }

    showInstantFeedback(itemKey, quantity) {
      // Minimal feedback - non più opacity perché la UI è già aggiornata
    }

    // ============ RICALCOLO SCONTO BANCALE VIA WORKER ============
// KH: metodo recalculateBancaleDiscount (sconto bancale) morto rimosso


    // ============ OPTIMIZED DRAWER CONTROLS ============
    setupOptimizedDrawerControls() {
      // FORM SUBMIT PER CHECKOUT - SUPPORTO MOBILE
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (form.classList.contains('fx-drawer-form') || form.querySelector('.fx-checkout-btn')) {
          // Lascia che il form si submetti normalmente
          return true;
        }
      });
      
      // OPEN DRAWER - selettori multipli
      const openSelectors = [
        '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]',
        '.cart-drawer-toggle',
        '.Header__CartIcon',
        '.mobile-cart-trigger',
        '.cart-icon',
        '.cart-link',
        '.cart-count',
        '[data-cart-count]',
        '.Header__CartCount',
        '.mobile-cart-count-clean'
      ];
      
      openSelectors.forEach(selector => {
        document.addEventListener('click', (e) => {
          if (e.target.closest(selector)) {
            e.preventDefault();
            e.stopPropagation();
            this.openDrawerInstant();
            return false;
          }
        });
      });
      
      // CLOSE DRAWER
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]')) {
          e.preventDefault();
          this.closeDrawerInstant();
        }
      });
      
      // CATEGORIES BUTTON - CHIUDI DRAWER E VAI ALLE CATEGORIE
      document.addEventListener('click', (e) => {
        if (e.target.closest('.fx-discover-btn')) {
          e.preventDefault();

          // HAPTIC FEEDBACK
          if (navigator.vibrate) {
            navigator.vibrate(50);
          }
          
          // CHIUDI DRAWER
          this.closeDrawerInstant();
          
          // VAI ALLE CATEGORIE IMMEDIATAMENTE
          window.location.href = '/collections/all';
        }
      });
      
      // ESC KEY
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer && this.drawer.getAttribute('aria-hidden') === 'false') {
          this.closeDrawerInstant();
        }
      });
      
      // INTERCETTA FORM ADD TO CART E APRI DRAWER DOPO
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (form && form.action && form.action.includes('/cart/add')) {
          // Lascia che il form si submit normalmente, poi apri il drawer
          setTimeout(() => {
            this.openDrawerInstant();
          }, 500);
        }
      });
    }
    
    setupOptimizedNoteControls() {
      const noteToggle = document.getElementById('aiNoteToggle');
      const notesContainer = document.getElementById('aiNotesContainer');
      const noteTextarea = document.getElementById('cart-note');
      const noteButtonText = document.getElementById('aiNoteButtonText');
      const saveButton = document.querySelector('.fx-save-note-btn');
      
      if (noteToggle && notesContainer) {
        noteToggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const isHidden = notesContainer.getAttribute('aria-hidden') === 'true';
          
          if (isHidden) {
            // Apri il pannello note
            notesContainer.setAttribute('aria-hidden', 'false');
            notesContainer.style.display = 'block';
            if (noteButtonText) {
              noteButtonText.textContent = 'Modifica nota';
            }
            // Focus sulla textarea
            if (noteTextarea) {
              noteTextarea.focus();
            }
          } else {
            // Chiudi il pannello note e salva
            notesContainer.setAttribute('aria-hidden', 'true');
            notesContainer.style.display = 'none';
            if (noteButtonText) {
              noteButtonText.textContent = 'Aggiungi nota';
            }
            this.saveCartNoteInstant();
          }
        });
      }
      
      // Pulsante Salva Nota
      if (saveButton && notesContainer) {
        saveButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Salva e chiudi
          this.saveCartNoteInstant();
          notesContainer.setAttribute('aria-hidden', 'true');
          notesContainer.style.display = 'none';
          if (noteButtonText) {
            noteButtonText.textContent = noteTextarea && noteTextarea.value ? 'Modifica nota' : 'Aggiungi nota';
          }
        });
      }
      
      // Auto-save mentre si digita
      if (noteTextarea) {
        let saveTimeout;
        noteTextarea.addEventListener('input', () => {
          clearTimeout(saveTimeout);
          saveTimeout = setTimeout(() => {
            this.saveCartNoteInstant();
          }, 1000);
        });
        
        // Aggiorna il testo del pulsante in base al contenuto
        if (noteTextarea.value && noteButtonText) {
          noteButtonText.textContent = 'Modifica nota';
        }
      }
    }
    
    async saveCartNoteInstant() {
      const noteTextarea = document.getElementById('cart-note');
      if (!noteTextarea) return;
      
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            note: noteTextarea.value
          })
        });
        
      } catch (error) {
        // Note save error
      }
    }
    
    // ============ SMART MUTATION OBSERVER - ANTI-LOOP ============
    setupSmartMutationObserver() {
      const cartSelectors = [
        '.Cart__ItemList',
        '.cart-items',
        '[data-cart-items]'
      ];
      
      // EXCLUDE header elements to prevent loops
      const excludeSelectors = [
        '.Header__CartCount',
        '.cart-count', 
        '[data-cart-count]',
        '.cart-link__bubble'
      ];
      
      cartSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          // Skip if element is in header to prevent loops
          const isHeaderElement = excludeSelectors.some(excludeSelector => 
            element.closest(excludeSelector) || element.matches(excludeSelector)
          );
          
          if (isHeaderElement) {
            return;
          }
          
          const observer = new MutationObserver((mutations) => {
            const relevantMutation = mutations.some(mutation => 
              mutation.type === 'childList' && 
              (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) &&
              // Ignore mutations on our own elements
              !mutation.target.closest('#sidebar-cart')
            );
            
            if (relevantMutation) {
              // Debounced update to prevent loops
              if (this.mutationTimeout) {
                clearTimeout(this.mutationTimeout);
              }
              this.mutationTimeout = setTimeout(() => {
                this.instantCartUpdate('mutation', { selector });
              }, 1000);
            }
          });
          
          observer.observe(element, {
            childList: true,
            subtree: true
          });
        });
      });
    }
    
    setupPerformanceOptimizedObservers() {
      // PERFORMANCE OBSERVER for monitoring
      if ('PerformanceObserver' in window) {
        try {
          const observer = new PerformanceObserver((list) => {
            const entries = list.getEntries();
            entries.forEach(entry => {
              if (entry.duration > 100) {
                
              }
            });
          });
          
          observer.observe({ entryTypes: ['measure'] });
        } catch (error) {
          // Performance Observer not supported
        }
      }
    }
    
    // ============ INSTANT DRAWER OPERATIONS ============
    openDrawerInstant() {
      if (!this.drawer) return;

      // IMMEDIATE STATE CHANGE
      this.drawer.setAttribute('aria-hidden', 'false');
      // RIMOSSA: document.body.classList.add('drawer-open'); - Non più necessaria per evitare spostamenti del layout
      
      // RIPRISTINA VISIBILITÀ PULSANTE CATEGORIE
      const categoriesBtn = this.drawer.querySelector('.fx-discover-btn');
      if (categoriesBtn) {
        categoriesBtn.style.opacity = '';
        categoriesBtn.style.visibility = '';
      }
      
      // INSTANT REFRESH
      this.instantRefreshCart();
      
      // HAPTIC FEEDBACK
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }
    }
    
    closeDrawerInstant() {
      if (!this.drawer) return;

      // AGGIUNGI CLASSE PER TRANSIZIONE DI CHIUSURA
      this.drawer.classList.add('drawer-closing');
      
      // ATTENDERE LA FINE DELLA TRANSIZIONE PRIMA DI NASCONDERE
      setTimeout(() => {
        if (this.drawer) {
          this.drawer.setAttribute('aria-hidden', 'true');
          this.drawer.classList.remove('drawer-closing');
          // RIMOSSA: document.body.classList.remove('drawer-open'); - Non più necessaria per evitare spostamenti del layout
        }
      }, 400); // Stessa durata della transizione CSS (0.4s)
      
      // NASCONDI IMMEDIATAMENTE IL PULSANTE CATEGORIE
      const categoriesBtn = this.drawer.querySelector('.fx-discover-btn');
      if (categoriesBtn) {
        categoriesBtn.style.opacity = '0';
        categoriesBtn.style.visibility = 'hidden';
      }
      
      // SAVE NOTE
      this.saveCartNoteInstant();
    }
    
    async loadInitialCartInstant() {
      try {
        await this.instantRefreshCart();
      } catch (error) {
        // Initial cart error
      }
    }

    async instantRefreshCart() {
      try {
        const cartData = await this.instantFetchCart();
        if (cartData) {
          this.currentCart = cartData;
          await this.instantRenderCart();
          this.instantUpdateCounters();
        }
      } catch (error) {
        // Refresh error
      }
    }
    
    // ============ OPTIMIZED UTILITY FUNCTIONS ============
    forceElementsVisibilityInstant() {
      // INSTANT VISIBILITY FORCING con design system unificato
      const selectors = [
        '.FORCE-PRICE-CONTAINER',
        '.FORCE-CURRENT-PRICE', 
        '.FORCE-ORIGINAL-PRICE',
        '.FORCE-SAVINGS-BADGE',
        '.FORCE-DISCOUNT-BADGE',
        '.FORCE-IMAGE-CONTAINER',
        '.FORCE-IMAGE'
      ];
      
      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          element.style.display = element.classList.contains('FORCE-PRICE-CONTAINER') ? 'flex' : 
                                  element.classList.contains('FORCE-IMAGE-CONTAINER') ? 'flex' :
                                  'inline-block';
          element.style.visibility = 'visible';
          element.style.opacity = '1';
          element.style.zIndex = '999999';
          
          // APPLY UNIFIED FONT SYSTEM
          element.style.fontFamily = 'var(--fx-font)';
          
          // APPLY SPECIFIC PRICE STYLING CON PREZZO RIDOTTO
          if (element.classList.contains('FORCE-CURRENT-PRICE')) {
            element.style.fontSize = '1.3rem';
            element.style.fontWeight = '800';
            element.style.color = 'var(--fx-primary)';
            element.style.letterSpacing = '-0.02em';
            element.style.textShadow = '0 1px 3px rgba(79, 193, 62, 0.1)';
          }

          if (element.classList.contains('FORCE-ORIGINAL-PRICE')) {
            element.style.fontSize = '1rem';
            element.style.fontWeight = '500';
            element.style.color = 'var(--fx-text-dim)';
            element.style.textDecoration = 'line-through';
          }
          
          if (element.classList.contains('FORCE-SAVINGS-BADGE')) {
            element.style.fontSize = 'var(--fx-text-xs)';
            element.style.fontWeight = '700';
            element.style.background = 'var(--fx-gradient-danger)';
            element.style.color = 'white';
            element.style.padding = 'var(--fx-spacing-xs) var(--fx-spacing-base)';
            element.style.borderRadius = 'var(--fx-radius-lg)';
            element.style.textTransform = 'uppercase';
            element.style.letterSpacing = '0.05em';
          }
        });
      });
    }

    formatMoneyOptimized(cents) {
      // Separatore migliaia MANUALE (Intl it-IT non lo rende sui 4 cifre in alcuni browser)
      var pp = (cents / 100).toFixed(2).split('.');
      return pp[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + pp[1] + ' €';
    }
    
    getOptimizedImageUrl(url, size) {
      const cacheKey = `${url}_${size}`;
      
      if (this.imageCache.has(cacheKey)) {
        return this.imageCache.get(cacheKey);
      }
      
      if (!url) {
        const fallback = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Crect width='100%25' height='100%25' fill='%23f8f9fa'/%3E%3C/svg%3E";
        this.imageCache.set(cacheKey, fallback);
        return fallback;
      }
      
      let optimizedUrl = url;
      
      if (url.includes('shopify') && url.includes('cdn.shopify.com')) {
        const baseUrl = url.split('?')[0];
        const cleanUrl = baseUrl.replace(/_\d+x\d*\./, '.');
        const extension = cleanUrl.split('.').pop();
        const urlWithoutExtension = cleanUrl.replace(`.${extension}`, '');
        optimizedUrl = `${urlWithoutExtension}_${size}.${extension}`;
      }
      
      this.imageCache.set(cacheKey, optimizedUrl);
      return optimizedUrl;
    }
  }
  
  // ============ DEVICE DETECTION & MOBILE SAFE INTELLIGENTE ============
  const deviceInfo = {
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isTablet: /iPad|Android(?!.*Mobile)|Tablet/i.test(navigator.userAgent),
    isiOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent),
    hasTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    hasNotch: CSS.supports('padding: max(0px)'),
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    safeAreaTop: 0,
    safeAreaBottom: 0,
    needsSafeAreas: false
  };
  
  // DETECTA SE LE SAFE AREAS SONO DAVVERO NECESSARIE - SMART DETECTION
  function detectSafeAreasNeed() {
    if (!deviceInfo.isMobile) {
      deviceInfo.needsSafeAreas = false;
      return false;
    }
    
    const testElement = document.createElement('div');
    testElement.style.position = 'fixed';
    testElement.style.top = '0';
    testElement.style.left = '0';
    testElement.style.width = '1px';
    testElement.style.height = '1px';
    testElement.style.paddingTop = 'env(safe-area-inset-top)';
    testElement.style.paddingBottom = 'env(safe-area-inset-bottom)';
    document.body.appendChild(testElement);
    
    const computedStyle = getComputedStyle(testElement);
    deviceInfo.safeAreaTop = parseInt(computedStyle.paddingTop) || 0;
    deviceInfo.safeAreaBottom = parseInt(computedStyle.paddingBottom) || 0;
    
    document.body.removeChild(testElement);
    
    // SMART DETECTION - SOLO QUANDO REALMENTE NECESSARIE
    const hasSignificantTop = deviceInfo.safeAreaTop > 20;
    const hasSignificantBottom = deviceInfo.safeAreaBottom > 20;
    
    // NOTCH DETECTION PER iOS
    const hasNotchIndicators = deviceInfo.isiOS && (
      deviceInfo.screenHeight >= 812 || // iPhone X+
      window.screen.height >= 812 ||
      deviceInfo.hasNotch
    );
    
    // ALTRI INDICATORI DI SAFE AREAS NECESSARIE
    const hasStatusBarIssues = deviceInfo.isAndroid && deviceInfo.screenHeight >= 800;
    
    // APPLICA SAFE AREAS SOLO SE REALMENTE NECESSARIE
    deviceInfo.needsSafeAreas = hasSignificantTop || hasSignificantBottom || hasNotchIndicators || hasStatusBarIssues;

    return deviceInfo.needsSafeAreas;
  }
  
  function applySafeAreaClasses() {
    const drawer = document.getElementById('sidebar-cart');
    const footer = document.querySelector('.fx-drawer-footer');
    const header = document.querySelector('.fx-drawer-header');
    
    if (!drawer) return;
    
    if (deviceInfo.needsSafeAreas && deviceInfo.isMobile) {
      // APPLICA SAFE AREAS SOLO QUANDO NECESSARIO
      drawer.classList.add('mobile-safe-areas-needed');
      if (footer) footer.classList.add('mobile-safe-areas-needed');
      if (header) header.classList.add('mobile-safe-areas-needed');
    } else {
      // RIMUOVI SAFE AREAS SE NON NECESSARIE
      drawer.classList.remove('mobile-safe-areas-needed');
      if (footer) footer.classList.remove('mobile-safe-areas-needed');
      if (header) header.classList.remove('mobile-safe-areas-needed');
    }
  }
  
  function updateDrawerSizeInstant() {
    const drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    
    const width = deviceInfo.screenWidth;
    let drawerWidth;
    
    // CALCULATE WIDTH
    if (width <= 360) {
      drawerWidth = '100vw';
    } else if (width <= 767) {
      drawerWidth = '100vw';
    } else if (width <= 1024) {
      drawerWidth = 'min(70vw, 450px)';
    } else {
      drawerWidth = 'min(420px, 35vw)';
    }
    
    drawer.style.width = drawerWidth;
    
    // APPLICA SAFE AREAS SOLO QUANDO NECESSARIO
    if (deviceInfo.isMobile) {
      detectSafeAreasNeed();
      applySafeAreaClasses();
      
      // SOLO SE SAFE AREAS NECESSARIE, AGGIORNA CSS VARIABLES
      if (deviceInfo.needsSafeAreas) {
        const topOffset = Math.max(deviceInfo.safeAreaTop, 0);
        const bottomOffset = Math.max(deviceInfo.safeAreaBottom, 0);
        
        document.documentElement.style.setProperty('--fx-mobile-top-padding', `${topOffset}px`);
        document.documentElement.style.setProperty('--fx-mobile-bottom-padding', `${bottomOffset}px`);
      } else {
        // RESET SAFE AREAS SE NON NECESSARIE
        document.documentElement.style.setProperty('--fx-mobile-top-padding', '0px');
        document.documentElement.style.setProperty('--fx-mobile-bottom-padding', '0px');
      }
    } else {
      // DESKTOP - NESSUNA MODIFICA
      applySafeAreaClasses(); // rimuove le classi
    }
  }

  function handleResizeInstant() {
    deviceInfo.screenWidth = window.innerWidth;
    deviceInfo.screenHeight = window.innerHeight;

    updateDrawerSizeInstant();
  }
  
  // ============ INITIALIZATION INTELLIGENTE + CART LINK INTERCEPTOR ============
  function initUltraReactiveCartDrawer() {
    try {
      // DETECT SAFE AREAS SOLO SE MOBILE
      if (deviceInfo.isMobile) {
        detectSafeAreasNeed();
      }
      
      // INSTANT INITIALIZATION
      window.UltraReactiveCartManager = new UltraReactiveCartManager();
      
      updateDrawerSizeInstant();
      
      // INTERCETTA TUTTI I LINK AL CARRELLO E APRI IL DRAWER INVECE
      document.addEventListener('click', function(e) {
        const link = e.target.closest('a[href*="/cart"]');
        if (link) {
          const href = link.getAttribute('href');
          // Se è un link semplice al carrello (non specifici come /cart/add)
          if (href === '/cart' || href.endsWith('/cart') || href.includes('/cart?') || href.includes('/cart#')) {
            e.preventDefault();
            e.stopPropagation();
            if (window.UltraReactiveCartManager) {
              window.UltraReactiveCartManager.openDrawerInstant();
            }
            return false;
          }
        }
      }, { capture: true, passive: false });

    } catch (error) {
      // Initialization error
    }
  }
  
  // ============ EVENT LISTENERS INTELLIGENTI ============
  let resizeTimeout;
  let orientationTimeout;
  
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResizeInstant, 50);
  });
  
  window.addEventListener('orientationchange', function() {
    clearTimeout(orientationTimeout);
    orientationTimeout = setTimeout(() => {
      handleResizeInstant();
    }, 150);
  });
  
  // MOBILE KEYBOARD DETECTION - SOLO QUANDO SAFE AREAS NECESSARIE
  if (deviceInfo.isMobile) {
    let initialViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    
    function handleViewportChange() {
      // SOLO SE SAFE AREAS SONO NECESSARIE
      if (!deviceInfo.needsSafeAreas) return;
      
      const currentHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const heightDifference = initialViewportHeight - currentHeight;
      
      if (heightDifference > 150) {
        // KEYBOARD IS VISIBLE
        const drawer = document.getElementById('sidebar-cart');
        if (drawer && drawer.classList.contains('mobile-safe-areas-needed')) {
          const topOffset = Math.max(deviceInfo.safeAreaTop, 0);
          drawer.style.height = `${currentHeight - topOffset}px`;
        }
      } else {
        // KEYBOARD IS HIDDEN
        handleResizeInstant();
      }
    }
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
      
      // ANDROID NAVIGATION BAR FIX
      function adjustForAndroidNavBar() {
        const drawer = document.getElementById('sidebar-cart');
        const footer = drawer?.querySelector('.fx-drawer-footer');
        
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          const vvHeight = window.visualViewport.height;
          const windowHeight = window.innerHeight;
          const navBarHeight = windowHeight - vvHeight;
          
          // Se c'è una navigation bar Android (differenza > 20px)
          if (navBarHeight > 20 && footer) {
            const safePadding = Math.max(navBarHeight + 24, 60);
            footer.style.paddingBottom = `${safePadding}px`;
          }
        }
      }
      
      window.visualViewport.addEventListener('resize', adjustForAndroidNavBar);
      window.visualViewport.addEventListener('scroll', adjustForAndroidNavBar, { passive: true });
      setTimeout(adjustForAndroidNavBar, 100);
      
    } else {
      window.addEventListener('resize', handleViewportChange);
    }
    
    // ANDROID FALLBACK SENZA VISUAL VIEWPORT
    if (/Android/i.test(navigator.userAgent)) {
      const footer = document.querySelector('.fx-drawer-footer');
      if (footer) {
        // Forza padding minimo per Android
        const currentPadding = parseInt(window.getComputedStyle(footer).paddingBottom) || 16;
        if (currentPadding < 60) {
          footer.style.paddingBottom = '60px';
        }
      }
    }
  }
  
  // iOS SAFARI SPECIFIC - SOLO QUANDO SAFE AREAS NECESSARIE
  if (deviceInfo.isiOS) {
    let lastHeight = window.innerHeight;
    
    window.addEventListener('resize', function() {
      // SOLO SE SAFE AREAS SONO NECESSARIE
      if (!deviceInfo.needsSafeAreas) return;
      
      const currentHeight = window.innerHeight;
      if (Math.abs(currentHeight - lastHeight) < 100) {
        // LIKELY ADDRESS BAR HIDE/SHOW
        setTimeout(handleResizeInstant, 100);
      }
      lastHeight = currentHeight;
    });
  }
  
  // ============ GLOBAL API ============
  window.AICartDrawer = {
    open: function() {
      if (window.UltraReactiveCartManager) {
        window.UltraReactiveCartManager.openDrawerInstant();
      }
    },
    
    close: function() {
      if (window.UltraReactiveCartManager) {
        window.UltraReactiveCartManager.closeDrawerInstant();
      }
    },
    
    refresh: function() {
      if (window.UltraReactiveCartManager) {
        return window.UltraReactiveCartManager.instantRefreshCart();
      }
    },
    
    forceUpdate: function() {
      if (window.UltraReactiveCartManager) {
        window.UltraReactiveCartManager.instantCartUpdate('forced', {});
      }
    }
  };
  
  // ============ START INITIALIZATION ============
  initUltraReactiveCartDrawer();
  
  // ADDITIONAL CART EVENT HANDLERS
  document.addEventListener('cart:updated', function() {
    if (window.UltraReactiveCartManager) {
      window.UltraReactiveCartManager.instantCartUpdate('external_cart_updated', {});
    }
  });
});

// ============ FORCE ELEMENTS VISIBILITY - INSTANT VERSION WITH UNIFIED DESIGN AND REDUCED PRICE ============
function forceElementsVisibilityGlobal() {
  const selectors = {
    '.FORCE-PRICE-CONTAINER': { 
      display: 'flex', 
      visibility: 'visible', 
      opacity: '1', 
      zIndex: '999999',
      fontFamily: 'var(--fx-font)',
      gap: 'var(--fx-spacing-sm)',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255, 255, 255, 0.8)',
      borderRadius: 'var(--fx-radius-base)',
      padding: 'var(--fx-spacing-sm) var(--fx-spacing-base)',
      boxShadow: '0 2px 8px rgba(79, 193, 62, 0.08)',
      backdropFilter: 'blur(8px)'
    },
    '.FORCE-CURRENT-PRICE': {
      display: 'inline-block',
      visibility: 'visible',
      opacity: '1',
      color: 'var(--fx-primary)',
      fontWeight: '800',
      zIndex: '999999',
      fontFamily: 'var(--fx-font)',
      fontSize: '1.3rem',
      letterSpacing: '-0.02em',
      textShadow: '0 1px 3px rgba(79, 193, 62, 0.1)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    },
    '.FORCE-ORIGINAL-PRICE': {
      display: 'inline-block',
      visibility: 'visible',
      opacity: '1',
      color: 'var(--fx-text-dim)',
      textDecoration: 'line-through',
      zIndex: '999999',
      fontFamily: 'var(--fx-font)',
      fontSize: '1rem',
      fontWeight: '500'
    },
    '.FORCE-SAVINGS-BADGE': { 
      display: 'inline-block', 
      visibility: 'visible', 
      opacity: '1', 
      background: 'var(--fx-gradient-danger)', 
      color: 'white', 
      zIndex: '999999',
      fontFamily: 'var(--fx-font)',
      fontSize: 'var(--fx-text-xs)',
      fontWeight: '700',
      padding: 'var(--fx-spacing-xs) var(--fx-spacing-base)',
      borderRadius: 'var(--fx-radius-lg)',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },
    '.FORCE-DISCOUNT-BADGE': { 
      display: 'block', 
      visibility: 'visible', 
      opacity: '1', 
      position: 'absolute', 
      background: 'var(--fx-gradient-danger)', 
      color: 'white', 
      zIndex: '999999',
      fontFamily: 'var(--fx-font)',
      fontSize: 'var(--fx-text-2xs)',
      fontWeight: '700',
      padding: 'var(--fx-spacing-xs) var(--fx-spacing-sm)',
      borderRadius: 'var(--fx-radius-base)',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      top: 'var(--fx-spacing-sm)',
      left: 'var(--fx-spacing-sm)',
      textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)'
    },
    '.FORCE-IMAGE-CONTAINER': { 
      display: 'flex', 
      visibility: 'visible', 
      opacity: '1', 
      alignItems: 'center', 
      justifyContent: 'center', 
      zIndex: '999999',
      borderRadius: 'var(--fx-radius-lg)',
      overflow: 'hidden',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    },
    '.FORCE-IMAGE': { 
      display: 'block', 
      visibility: 'visible', 
      opacity: '1', 
      width: '100%', 
      height: '100%', 
      objectFit: 'cover', 
      zIndex: '999999',
      borderRadius: 'var(--fx-radius-lg)',
      transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    }
  };
  
  Object.entries(selectors).forEach(([selector, styles]) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      Object.assign(element.style, styles);
    });
  });
}

// RUN FORCE ELEMENTS IMMEDIATELY AND PERIODICALLY
setTimeout(forceElementsVisibilityGlobal, 100);
setInterval(forceElementsVisibilityGlobal, 2000);

// ============ ANDROID NAVIGATION BAR DETECTION ============
function detectAndroidNavigationBar() {
  const footer = document.querySelector('.fx-drawer-footer');
  const main = document.querySelector('.fx-drawer-main');
  
  if (!footer || !main) return;
  
  // Rileva se c'è una navigation bar Android
  const hasNavigationBar = () => {
    // Check if Visual Viewport API is available
    if ('visualViewport' in window) {
      const viewportHeight = window.visualViewport.height;
      const windowHeight = window.innerHeight;
      // Se la differenza è significativa, c'è una navigation bar
      return (windowHeight - viewportHeight) > 20;
    }
    
    // Fallback: controlla se è Android
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isMobile = window.innerWidth <= 767;
    
    // Su Android mobile, assume che ci sia navigation bar
    return isAndroid && isMobile;
  };
  
  // Applica o rimuove la classe in base alla presenza della navigation bar
  const updateNavigationBarClass = () => {
    if (hasNavigationBar()) {
      footer.classList.add('android-nav-detected');
      main.classList.add('android-nav-detected');
    } else {
      footer.classList.remove('android-nav-detected');
      main.classList.remove('android-nav-detected');
    }
  };
  
  // Check iniziale
  updateNavigationBarClass();
  
  // Ricontrolla quando cambiano le dimensioni
  if ('visualViewport' in window) {
    window.visualViewport.addEventListener('resize', updateNavigationBarClass);
    window.visualViewport.addEventListener('scroll', updateNavigationBarClass, { passive: true });
  }
  
  // Fallback con window resize
  window.addEventListener('resize', updateNavigationBarClass);
  window.addEventListener('orientationchange', updateNavigationBarClass);
}

// Inizializza il rilevamento quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', detectAndroidNavigationBar);
} else {
  detectAndroidNavigationBar();
}

// Ricontrolla quando il drawer viene aperto
document.addEventListener('drawer:opened', detectAndroidNavigationBar);
document.addEventListener('cart:opened', detectAndroidNavigationBar);

// Il CSS gestisce già tutti gli stili del pulsante checkout
